export default __webpack_public_path__ + "static/media/gileadStatM.e1934e92.svg";